var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 12a9 9 0 1 0 18.001 0A9 9 0 0 0 3 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10a3 3 0 1 0 6 0 3 3 0 0 0-6 0ZM6.168 18.849A4 4 0 0 1 10 16h4a4 4 0 0 1 3.834 2.855"
  }))));
};
export default SvgUser;